export class ITraconLocid{
    locid:string;
}

export class ITraconModelRequest{
    traconId: string;
    ayear: number;
    scenarioId: number;
    sYear:number;
    eYear:number;
    constructor ( traconId: string,ayear:number, scenarioId:number, sYear:number, eYear:number){
        this.traconId = traconId;
        this.ayear = ayear
        this.scenarioId = scenarioId;
        this.sYear = sYear;
        this.eYear = eYear;
    }
}
export class IYears{
    years:string;
}

export class ITraconModelResponse{
    traconId :string;
    locid:string;
    aYear:string;
    ifrItnAc:string;
    ifrItnAt:string;
    ifrItnGa :string;
    ifrItnMi :string;
    totOvers : string;
    message:string;
    constructor(){
        let message = 'a';
    }
}
export class ITraconModelSummaryResponse{
     lYear: number;
     fYear : number;
     sumFYear :number;
     traconYearlyRate :number;
}
export class ITraconModelReforecastAOPSIFR{
     msg: string;
}



/** WEBPACK FOOTER **
 ** ./app/system-management/tracon-models/tracon-model.ts
 **/